<template>
  <div class="aboutus-container">
    <header class="aboutus-container-header">About Us</header>
    <section>
      <article
        class="aboutus-container-item"
        v-for="(yy, index) in list"
        :key="index"
      >
        <div
          class="aboutus-container-item-avatar"
          :style="{
            backgroundImage:
              'url(' + $cdnPath.img + 'h5/us/avatar/' + yy.avatar + ')',
          }"
        ></div>
        <div class="aboutus-container-item-info">{{ yy.info }}</div>
      </article>
    </section>
    <section>
      <div class="aboutus-container-item">
        <div
          class="aboutus-container-timeline-header-img"
          :style="{
            backgroundImage: 'url(' + $cdnPath.img + 'h5/us/yylogo.jpg)',
          }"
        ></div>
        <article
          class="aboutus-container-timeline-item"
          v-for="(tl, index) in timeline"
          :key="index"
        >
          <h4>{{ tl.time }}</h4>
          <p>{{ tl.news }}</p>
        </article>
      </div>
    </section>
    <footer class="aboutus-container-footer">
      <div>
        <h4>联系我们：</h4>
        <div class="aboutus-container-footer-info">
          <p>
            <!-- QQ交流1群：&nbsp;297443896 <span style="color:#cb5432">（满）</span><br/>
       QQ交流2群：&nbsp;273083862<br/> -->
            商务微信：&nbsp;&nbsp;<span class="copy">2502391994</span><br />
            <!-- 官方(GM)QQ：&nbsp;&nbsp;1470937559<br />-->
            服务热线：&nbsp;&nbsp;<span class="copy">0755-86726600</span><br />
            客服微信：&nbsp;&nbsp;<span class="copy">dfacf222</span><br />
            客服时间：&nbsp;&nbsp;工作日（10:00 ~ 18:00）<br />
            <br />
            如有问题，欢迎您的来信。<br />
            商务合作：<span class="red copy">businesss@yymedias.com</span><br />
            产品建议：<span class="red copy">blabla@yymedias.com</span><br />
            BUG反馈：<span class="red copy">TOT@yymedias.com</span><br />

            如果侵犯了您的权益，请联系：<br />
            <span class="red copy">orz@yymedias.com</span><br />
            公 司：深圳市有影传媒有限公司<br />
            地 址：深圳市南山区沙河街道高发社区侨香路4080号侨城坊5号楼6A<br />
            邮 编：518053
            <br />
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          name: "W蜀黍",
          avatar: "w-P.png",
          info:
            "W就是我，颜色不一样的烟火。表面风轻云淡，内心惊涛拍岸。吐槽时毒舌，调侃时腹黑。玩文艺迎风流泪，扮深沉仰望星空。敢基敢腐无拘无束，有情有义不紧不慢。360度无死角，180度有气场。蜀黍你好，蜀黍再见！",
        },
        {
          name: "z蜀黍",
          avatar: "z-P.png",
          info:
            "曾几何时，我想等咱有了娃，一定要当成牛顿、爱因斯坦来养，起码也得是个毕加索。直到那一天，他看到我手中的JAVA编程大全，双目精光四射，我明白了人生的真谛：程序猿的事业必须500年不动摇。",
        },
        {
          name: "Summer",
          avatar: "summer-P.png",
          info:
            "心理学专业学霸，女流氓职业出身。可御可萌，忽正忽邪，总体黑化，偶尔洗白；节操已碎，文艺不死。大世界里的小个体，有梦便锦衣夜行，幸福得刀口舔蜜。每个人都是一座孤岛，所幸板块会漂移，轮船会发明，我们终相遇。漫漫迷途，终有一归；但行好事，莫问前途。",
        },
        {
          name: "Bobo",
          avatar: "bobo-P.png",
          info:
            "他们都说程序猿都是单身狗，我才不信呢。直到有天晚上，我半夜打电话给我的同事，问他在做什么呢， 他在那边喘着气不耐烦的说：在做一个几亿的项目呢！！！ 瞬间秒懂的我，还跟问一句：是合资的还是独资的？其实对于程序猿来说，合资独资有很大的区别吗？就像谈恋爱：找个人一起各干各的事，一起孤独而已... ",
        },
        {
          name: "圆圆",
          avatar: "Sunshine-P.png",
          info:
            "想做不食人间烟火的美少女，被生活压榨成了大大咧咧的女汉子，生活不易，且相识且珍惜，给个关注点赞，么么哒~",
        },
        {
          name: "张文栓",
          avatar: "Zhangws-P.png",
          info: "砥砺前行，干就得了。",
        },
        {
          name: "罗小瑶",
          avatar: "Yunny-P.png",
          info:
            "本人曾获得的成就：国家一级退堂鼓艺术家，中国好食堂干饭王称号获得者，亚洲最大柠檬批发商，月收入倒欠两千花呗等等成绩，只要你心中有咸鱼你也能像我一样优秀。",
        },
        {
          name: "柚子",
          avatar: "Never-P.png",
          info:
            "Hello，大家好，我是never，一个有趣的灵魂，皮囊单身成瘾，一直在如何拥有马甲线的路上狂奔。“身体和灵魂总有一个在路上”，喜欢一切新奇有趣的东西，好奇于未知，一直相信好运藏在努力里~",
        },
        {
          name: "袁昕宇",
          avatar: "Lamar-P.png",
          info:
            "上得厅堂，下的厨房，为剪视频而生的工具人。外表冷漠，内里似火。典型白羊座。",
        },
        {
          name: "柯梦雪",
          avatar: "Snow-P.png",
          info:
            "身上是揣着大宝藏的沙雕女孩本人，灵魂像个大宝藏，越是挖掘越有趣。如果你喜欢水瓶座，那你可以太有眼光了！",
        },
        {
          name: "石浩",
          avatar: "Mateo-P.png",
          info:
            "Hay tres tipos de personas: los que saben contar y los que no. 世上有三类人，会数数的和不会数数的。",
        },
        {
          name: "李利",
          avatar: "Lily-P.jpg",
          info:
            "说好的当一辈子撸图仔，少一天、一小时、一分钟、一秒钟，都不能算是一辈子。",
        },
        {
          name: "汪钱萍",
          avatar: "Beat-P.png",
          info:
            "大家好，在下是：尬聊王者玩家，金鱼记忆大师，每天都很烦专家，线下轻度社恐患者，emmm...其实以上都跟我没关系，我只是个平平无奇的超级小可爱罢辽。",
        },
        {
          name: "张威庭",
          avatar: "Tate-P.jpg",
          info:
            "广东潮汕人，正经程序员，哲理名言：Code最好时间是十年前，其次是现在。眼镜一戴，见谁都爱，喜欢穿拖孩，喜欢研究有颜色的事物，熟悉手技24级，做好手中事，珍惜年轻人。",
        },
        {
          name: "王惠铃",
          avatar: "ZZ-P.png",
          info:
            "美食控，C&V大神，二次元宅女，想减肥减不下来的不知名同学一枚。",
        },
        {
          name: "彭彭",
          avatar: "Iirs-P.png",
          info:
            "Jack Rabbit餐厅Vincent舞步驾驭者，神奈川冲浪里狂热，21世纪安迪沃霍尔的簇拥，帕米尔高原上的金瞳孔雄鹰！",
        },
        {
          name: "彭燕玲",
          avatar: "Yanling-P.jpg",
          info:
            "我是小财神，我负责给大家发钱，我性格热情开朗待人友好人诚实谦虚工作勤奋认真负责能吃苦耐劳尽职尽责有耐心具有亲和力平易近人。想吃我手上的爆米花嘛，来，我发给你。",
        },
        {
          name: "欧丽婵",
          avatar: "LittleOu-P.png",
          info:
            "你看我有着一头乌黑亮丽的头发，一双炯炯有神的眼睛，还有一双弯弯的眉毛，不是个美女起码也是个靓女吧，直到我看到我手中的账本，才知道财务的事业雷打不动风吹不倒。",
        },
        {
          name: "谢煜",
          avatar: "Levine-P.jpg",
          info:
            "“ 不要这么容易 就想放弃 就像我说的，追不到的梦想 换个梦不就得了，为自己的人生鲜艳上色，先把爱涂上喜欢的颜色，笑一个吧 功成名就不是目的，让自己快乐快乐 这才叫做意义。” 当你烦恼迷茫难过的时候，音乐或许就是你的解药，没有什么是一次K歌解决不了的，如果有 那就多K几次。",
        },
      ],
      timeline: [
        { time: "未来", news: "一切才刚刚开始" },
        { time: "2020年11月", news: "有影APP 2周年上线" },
        { time: "2020年10月", news: "捷成华视网聚战略合作" },
        {
          time: "2020年08月",
          news: "小米创维等OTT厂商独家影视短视频内容提供方",
        },
        { time: "2020年03月", news: "成立有影传媒MCN" },
        {
          time: "2019年09月",
          news: "旗下抖音影视类账号“电影十级学者”粉丝破150W",
        },
        {
          time: "2019年01月",
          news: "有影传媒合作客户440家，接入合作服务号突破1000家",
        },
        {
          time: "2018年12月",
          news: "有影平台连续3月位居微信内图文类内容平台第一",
        },
        { time: "2018年11月", news: "有影APP 1.0上线" },
        { time: "2018年11月", news: "有影试水短视频项目" },
        {
          time: "2018年10月",
          news: "有影传媒联合28推、财神大咖会，多城市线下宣传活动反响热烈",
        },
        { time: "2018年09月", news: "分销平台2.0上线" },
        { time: "2018年07月", news: "单合作客户最高月营收规模突破百万" },
        { time: "2018年04月", news: "分销平台1.0正式公测上线" },
        { time: "2018年03月", news: "有影万部影视内容库搭建完成" },
        { time: "2017年11月", news: "深圳有影传媒有限公司正式注册成立" },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.aboutus-container {
  background-color: #f0f0f0;
  &-header {
    width: 100%;
    position: relative;
    font-size: 0.78rem;
    text-align: center;
    background-color: #222;
    color: #fff;
    line-height: 2.2em;
    border-bottom: 0.2rem solid #666;
  }
  &-footer {
    padding: 0.4rem;
    width: 100%;
    background-color: #222;
    color: #b5b5b5;
    line-height: 1.7em;
    border-top: 0.2rem solid #666;
    h4 {
      font-size: 1.2em;
    }
    &-info {
      padding: 0.2rem;
    }
    .red {
      color: #cb5432;
    }
    .copy {
      -webkit-user-select: auto; /*webkit浏览器*/
      user-select: auto;
    }
  }
  section {
    padding: 0.4rem;
    margin: 0 auto;
    min-width: 300px;
    max-width: 600px;
  }
  &-item {
    width: 100%;
    margin-bottom: 0.8rem;
    border-radius: 0.2rem;
    overflow: hidden;
    border-bottom: 0.06rem solid #e3e3e3;
    background-color: #fff;
    &-avatar {
      padding-top: 45.454546%;
      position: relative;
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
    &-info {
      padding: 0.4rem;
      padding-top: 0.2rem;
      color: #636363;
      line-height: 1.7em;
      font-size: 0.32rem;
    }
  }

  &-timeline {
    &-header-img {
      padding-top: 36.321%;
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
    &-item {
      padding: 0.2rem 0.4rem;
      line-height: 1.5em;
      position: relative;
      h4 {
        color: #cb5432;
        font-weight: normal;
      }
      p {
        color: #666;
        text-indent: 2em;
      }
      &::before {
        content: "";
        height: 1px;
        width: 100%;
        position: absolute;
        top: 0;
        left: 5%;
        width: 90%;
        transform: scaleY(0.5);
        border-top: 1px solid #f2f2f2;
      }
    }
  }
}
</style>